module.exports = __webpack_public_path__ + "static/storytimeDesktop-b969af44f15aab4328ec50ece4bfb0a3.jpg";